<template>
  <div>
    <div class="content-box">
      <div class="element-wrapper">
        <div class="element-box">
          <h5 class="form-header">
            Cotización de Requerimiento
            <span v-if="current.id">#{{ current.numero }}</span>
            &nbsp;
            <span v-if="current.id" class="badge" :class="{
              'badge-success': current.estado == 'A',
              'badge-warning': current.estado == 'B',
              'badge-danger': current.estado == '9',
            }">{{ current.estado_str }}</span>
            <span v-if="current.esta_vencida" class="badge badge-danger">Vencida</span>
            <span v-if="current.requerimiento" class="badge badge-info">
              Asignada al requerimiento #{{ current.requerimiento.numero }}
            </span>
            <div class="st-meta float-right" v-if="current.id">
              <div class="btn-group">
                <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                  data-toggle="dropdown" type="button">
                  <i class="fa fa-cogs"></i>
                  Acciones
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <button class="dropdown-item" type="button" @click="cerrar" :disabled="!editable">
                    <i class="fas fa-check"></i>
                    Cerrar Cotización
                  </button>
                  <button class="dropdown-item" type="button" @click="abrir"
                    :disabled="current.estado != 'B' || current.esta_vencida || !!current.requerimiento">
                    <i class="fa fa-unlock"></i>
                    Abrir Cotización
                  </button>
                  <button class="dropdown-item" type="button" @click="anular" :disabled="!puedeAnular">
                    <i class="fa fa-archive"></i>
                    Anular Cotización
                  </button>
                  <div class="dropdown-divider"></div>
                  <button class="dropdown-item" type="button" @click="clonar">
                    <i class="fa fa-copy"></i>
                    Clonar Cotización
                  </button>
                  <button class="dropdown-item" type="button" @click="trasladarATienda">
                    <i class="fa fa-exchange-alt"></i>
                    Trasladar a Tienda
                  </button>
                </div>
              </div>
            </div>
          </h5>

          <div v-if="current.cotizacion_origen_numero" class="alert alert-info py-2">
            Clonada de la cotización #{{ current.cotizacion_origen_numero }}
            <span v-if="current.usuario_clona_obj">
              por {{ current.usuario_clona_obj.name || current.usuario_clona_obj.username }}
            </span>
            <span v-if="current.fecha_clonacion"> el {{ formatoFechaHora(current.fecha_clonacion) }}</span>
          </div>

          <!-- Cotizacion creada desde un requerimiento de traslado: queda asignada a el -->
          <div v-if="!current.id && reqOrigen" class="alert py-2"
            :class="reqOrigen.cotizacion ? 'alert-warning' : 'alert-info'">
            <template v-if="reqOrigen.cotizacion">
              <i class="fas fa-exclamation-triangle"></i>
              El requerimiento <b>#{{ reqOrigen.numero }}</b> ya tiene asignada la cotización
              <b>#{{ reqOrigen.cotizacion.numero }}</b>; no se puede crear otra.
            </template>
            <template v-else>
              <i class="fas fa-link"></i>
              Esta cotización se creará para el requerimiento <b>#{{ reqOrigen.numero }}</b>
              y quedará asignada a él.
            </template>
          </div>

          <div class="row">
            <div class="col-sm-3">
              <TiendaSelectComponent titulo="Tienda" :current="current"
                :disabled="!!current.id || esDesdeRequerimiento"
                :tiendas_lista="current.id || esDesdeRequerimiento ? null : tiendasAsignadas" />
            </div>
            <div class="col-sm-5">
              <SuperClienteTiendaSelectComponent :value="superClienteSel" :tienda="current.tienda"
                :disabled="!editableEncabezado" :error="errors.super_cliente ? errors.super_cliente[0] : null"
                @input="onChangeSuperCliente" />
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label>Fecha</label>
                <input class="form-control" :value="current.fecha" disabled type="text" />
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group">
                <label :class="{ 'text-danger': errors.fecha_vence }">Vence</label>
                <input class="form-control" v-model="fecha_vence_input" :disabled="!editableEncabezado"
                  :min="fecha_minima_vence" type="date" />
                <small v-if="!current.id" class="form-text text-muted">
                  Si se deja vacía vence en 5 días.
                </small>
                <small v-if="errors.fecha_vence" class="form-text text-danger">{{ errors.fecha_vence[0] }}</small>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label :class="{ 'text-danger': errors.cliente_nit }">NIT</label>
                <input class="form-control" v-model="current.cliente_nit" disabled type="text" />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label :class="{ 'text-danger': errors.cliente_nombre }">Nombre</label>
                <input class="form-control" v-model="current.cliente_nombre" disabled type="text" />
                <small v-if="errors.cliente_nombre" class="form-text text-danger">{{
                  errors.cliente_nombre[0] }}</small>
              </div>
            </div>
            <div class="col-sm-5">
              <div class="form-group">
                <label :class="{ 'text-danger': errors.cliente_direccion }">Dirección</label>
                <input class="form-control" v-model="current.cliente_direccion" disabled type="text" />
                <small v-if="errors.cliente_direccion" class="form-text text-danger">{{
                  errors.cliente_direccion[0] }}</small>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label>Correo electrónico</label>
                <input class="form-control" v-model="current.email" :disabled="!editableEncabezado" type="text" />
              </div>
            </div>
            <div class="col-sm-4" v-if="current.id && current.vendedor_obj">
              <div class="form-group">
                <label>Creada por</label>
                <input class="form-control" :value="current.vendedor_obj.name || current.vendedor_obj.username"
                  disabled type="text" />
              </div>
            </div>
          </div>
          <small v-if="errors.detail" class="form-text text-danger">{{ errors.detail }}</small>

          <div class="form-buttons-w d-flex align-items-center">
            <router-link class="btn btn-sm btn-info mr-2" :to="{ name: 'inventario-cotizaciones-requerimiento' }">
              <i class="os-icon os-icon-chevrons-left"></i>
              Ver todas las cotizaciones
            </router-link>
            <button class="btn btn-sm btn-success" type="button" @click="guardar" v-if="editableEncabezado"
              :disabled="!current.id && !!reqOrigen && !!reqOrigen.cotizacion">
              {{ current.id ? "Guardar cambios" : "Crear cotización" }}
              <i class="os-icon os-icon-checkmark"></i>
            </button>
          </div>

          <div v-if="current.id">
            <br />
            <button type="button" class="btn btn-sm btn-dark btn-block" @click="showModalAddDetail"
              v-if="editable">
              <i class="fa fa-plus"></i>
              Agregar Producto
            </button>
            <br />
            <div class="table-responsive">
              <table class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Producto</th>
                    <th class="text-center">Unidad Medida</th>
                    <th class="text-center">Cantidad</th>
                    <th class="text-center">Unidades</th>
                    <th class="text-right">Precio</th>
                    <th class="text-right">Total</th>
                    <th class="text-center" v-if="editable">Opciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="linea in current.cxccotizaciond_set" :key="linea.id">
                    <td>
                      <b>{{ linea.producto }}</b>
                      <i v-if="!linea.es_inventariable" class="fas fa-exclamation-triangle text-warning"
                        title="No está marcado como inventariable"></i>
                    </td>
                    <td>{{ linea.producto_nombre }}</td>
                    <td class="text-center">{{ linea.unidad_medida_nombre }}</td>
                    <td class="text-center" style="width: 140px">
                      <input v-if="editable" class="form-control form-control-sm text-center"
                        v-model="linea.cantidad_um" type="text" @keyup.enter="modificarLinea(linea)"
                        @blur="modificarLinea(linea)" />
                      <span v-else>{{ linea.cantidad_um }}</span>
                    </td>
                    <td class="text-center">{{ linea.cantidad }}</td>
                    <td class="text-right">Q {{ linea.precio }}</td>
                    <td class="text-right">Q {{ linea.total }}</td>
                    <td class="text-center" v-if="editable">
                      <button class="btn btn-sm btn-danger" type="button" @click="eliminarLinea(linea)">
                        <i class="fa fa-trash"></i>
                        Eliminar
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <th colspan="6" class="text-right">Total</th>
                    <th class="text-right">Q {{ current.total }}</th>
                    <th v-if="editable"></th>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="modal fade" id="modalAddDetailCotizacionReq" role="dialog" tabindex="-1">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ProductoSelectComponentV2 @onChangeProducto="onChangeProducto" :current="detalle"
              :tienda="current.tienda"></ProductoSelectComponentV2>
            <ProductoUnidadMedidaSelectComponent :current="detalle.producto" />
            <div class="form-group">
              <label>Cantidad</label>
              <input v-model="detalle.cantidad_um" class="form-control" placeholder="Cantidad" type="text"
                style="text-align: center; font-size: 200%" />
            </div>
            <small v-if="detalle.errors && detalle.errors.detail" class="form-text text-danger">{{
              detalle.errors.detail }}</small>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="agregarLinea" type="button">Agregar</button>
            <button class="btn btn-secondary" ref="cerrarModal" data-dismiss="modal" type="button">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Traslado de una cotizacion de otra tienda a la tienda de esta cotizacion -->
    <TrasladarCotizacionModal v-if="current.id" ref="modalTraslado" :cotizacion-id="current.id"
      :tienda-destino="current.tienda" @trasladada="onTrasladada" />
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import SuperClienteTiendaSelectComponent from "./SuperClienteTiendaSelectComponent";
import ProductoSelectComponentV2 from "@/components/commons/ProductoSelectComponentV2";
import ProductoUnidadMedidaSelectComponent from "@/components/commons/ProductoUnidadMedidaSelectComponent";
import { mostrarResumenCargaCotizacion } from "./resumenCargaCotizacion";
import TrasladarCotizacionModal from "./TrasladarCotizacionModal";

const MODULO = "cxc";
const PATH = "cotizaciones";

function detalleVacio() {
  return {
    producto: {
      sku: null,
      unidad_medida: null,
      errors: [],
    },
    cantidad_um: "",
    errors: {},
  };
}

export default {
  components: {
    TiendaSelectComponent,
    SuperClienteTiendaSelectComponent,
    ProductoSelectComponentV2,
    ProductoUnidadMedidaSelectComponent,
    TrasladarCotizacionModal,
  },
  data() {
    return {
      current: {
        id: null,
        tienda: null,
        estado: "A",
        super_cliente: null,
        cliente_nit: "",
        cliente_nombre: "",
        cliente_direccion: "",
        email: "",
        fecha: "",
        fecha_vence: null,
        cxccotizaciond_set: [],
        requerimiento: null,
        errors: {},
      },
      superClienteSel: null,
      fecha_vence_input: "",
      fecha_minima_vence: "",
      tiendasAsignadas: [],
      reqOrigen: null,
      errors: {},
      detalle: detalleVacio(),
    };
  },
  computed: {
    editable() {
      // Asignada y abierta solo ocurre si se creo desde el requerimiento:
      // se edita mientras el requerimiento siga abierto.
      return (
        !!this.current.id &&
        this.current.estado == "A" &&
        (!this.current.requerimiento || this.current.requerimiento.estado == "A")
      );
    },
    esDesdeRequerimiento() {
      return !this.current.id && !!this.$route.query.req;
    },
    editableEncabezado() {
      return !this.current.id || this.editable;
    },
    puedeAnular() {
      if (!this.current.id || this.current.estado == "9") {
        return false;
      }
      return !this.current.requerimiento || this.current.requerimiento.estado == "9";
    },
  },
  mounted() {
    this.cargarFechaActual();
    if (this.$route.params.id) {
      this.refreshCurrent();
    } else {
      if (this.$route.query.req) {
        this.cargarRequerimientoOrigen();
      }
      this.cargarTiendasAsignadas();
    }
  },
  watch: {
    "$route.params.id": function (id) {
      if (id) {
        this.refreshCurrent();
      }
    },
    // El supercliente debe ser de la tienda: al cambiarla en una cotizacion nueva se limpia
    "current.tienda": function () {
      if (!this.current.id && this.superClienteSel) {
        this.onChangeSuperCliente(null);
      }
    },
  },
  methods: {
    /**
     * Tiendas para una cotizacion nueva segun tienda_usuario.
     * - Solo se listan las tiendas asignadas al usuario (activas).
     * - Si viene ?tienda= desde el requerimiento y es una tienda asignada, queda seleccionada.
     * - Si no, se selecciona la predeterminada o la unica asignada.
     * - Si no tiene asignadas, el select usa el listado general.
     */
    cargarTiendasAsignadas() {
      if (this.$route.query.tienda) {
        // Tienda destino enviada desde el requerimiento de traslado
        this.current.tienda = String(this.$route.query.tienda);
      }
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
        quitar_paginacion: true,
      })
        .then((response) => {
          const asignadas = Array.isArray(response.data)
            ? response.data
            : response.data.results || [];
          this.tiendasAsignadas = asignadas
            .map((item) => item.tienda)
            .filter((tienda) => tienda && tienda.activa);
          if (this.current.id || this.$route.query.req || this.tiendasAsignadas.length === 0) {
            // Desde el requerimiento la tienda la define el requerimiento
            return;
          }
          const codigos = this.tiendasAsignadas.map((tienda) => tienda.codigo);
          if (this.current.tienda && codigos.includes(this.current.tienda)) {
            return;
          }
          const predeterminada = asignadas.find(
            (item) => item.predeterminada && item.tienda && item.tienda.activa
          );
          const unica = this.tiendasAsignadas.length === 1 ? this.tiendasAsignadas[0] : null;
          const inicial = predeterminada ? predeterminada.tienda : unica;
          this.current.tienda = inicial ? inicial.codigo : null;
        })
        .catch(() => {
          this.tiendasAsignadas = [];
        });
    },
    /**
     * Requerimiento de traslado desde el que se crea la cotizacion (?req=).
     * Define la tienda y se muestra al usuario; el backend vuelve a validarlo.
     */
    cargarRequerimientoOrigen() {
      DynamicService.getByIdParams("inv", "req_traslado", this.$route.query.req, {})
        .then((response) => {
          const req = response.data;
          this.reqOrigen = {
            id: req.id,
            numero: req.numero,
            cotizacion: req.cotizacion || null,
          };
          if (!this.current.id && req.tienda) {
            this.current.tienda = req.tienda.codigo;
          }
        })
        .catch(() => {
          Notifications.alert.error("Cotización", "No se pudo cargar el requerimiento de origen");
        });
    },
    /**
     * Fecha actual del servidor: se muestra en Fecha para una cotizacion nueva
     * y se usa como minimo de Vence (no se permiten fechas pasadas).
     */
    cargarFechaActual() {
      CommonService.fecha_actual()
        .then((response) => {
          const hoy = response.data.fecha_actual;
          this.fecha_minima_vence = this.fechaIso(hoy);
          if (!this.current.id) {
            this.current.fecha = hoy;
          }
        })
        .catch(() => {
          this.fecha_minima_vence = moment().format("YYYY-MM-DD");
          if (!this.current.id) {
            this.current.fecha = moment().format("DD/MM/YYYY");
          }
        });
    },
    refreshCurrent() {
      DynamicService.getByIdParams(MODULO, PATH, this.$route.params.id, {}).then((response) => {
        const data = response.data;
        data.errors = {};
        this.current = data;
        this.fecha_vence_input = this.fechaIso(data.fecha_vence);
        this.superClienteSel = data.super_cliente_obj || null;
        this.errors = {};
      });
    },
    fechaIso(fecha) {
      // dd/mm/yyyy -> yyyy-mm-dd para el input date
      if (!fecha) {
        return "";
      }
      const partes = fecha.split("/");
      if (partes.length == 3) {
        return `${partes[2]}-${partes[1]}-${partes[0]}`;
      }
      return fecha;
    },
    formatoFechaHora(valor) {
      return moment(valor).format("DD/MM/YYYY HH:mm");
    },
    onChangeSuperCliente(superCliente) {
      // nit, nombre y direccion se toman del supercliente (el backend los vuelve a copiar)
      this.superClienteSel = superCliente;
      this.current.super_cliente = superCliente ? superCliente.codigo : null;
      this.current.cliente_nit = superCliente ? superCliente.nit : "";
      this.current.cliente_nombre = superCliente ? superCliente.nombre : "";
      this.current.cliente_direccion = superCliente ? superCliente.direccion : "";
    },
    mostrarError(titulo, error) {
      const data = (error.response && error.response.data) || {};
      this.errors = data && typeof data === "object" && !Array.isArray(data) ? data : {};
      Notifications.alert.error(titulo, this.textoError(data));
    },
    /**
     * Mensaje del backend: detail, lista de mensajes ["..."] o errores por campo { campo: ["..."] }.
     */
    textoError(data) {
      if (typeof data === "string" && data && data.trim().charAt(0) !== "<") {
        return data;
      }
      if (Array.isArray(data) && data.length > 0) {
        return data.join(" ");
      }
      if (data && data.detail) {
        return Array.isArray(data.detail) ? data.detail.join(" ") : String(data.detail);
      }
      if (data && typeof data === "object") {
        const mensajes = Object.values(data)
          .map((valor) => (Array.isArray(valor) ? valor.join(" ") : String(valor)))
          .filter((mensaje) => mensaje);
        if (mensajes.length > 0) {
          return mensajes.join(" ");
        }
      }
      return "Revise los datos ingresados";
    },
    mostrarAdvertencias(advertencias) {
      (advertencias || []).forEach((mensaje) => {
        Notifications.toast.warning("Advertencia", mensaje);
      });
    },
    guardar() {
      if (
        this.fecha_vence_input &&
        this.fecha_minima_vence &&
        this.fecha_vence_input < this.fecha_minima_vence
      ) {
        this.errors = { fecha_vence: ["La fecha de vencimiento no puede ser anterior a hoy."] };
        Notifications.alert.error("Cotización", "La fecha de vencimiento no puede ser anterior a hoy.");
        return;
      }
      if (!this.current.id && !this.superClienteSel) {
        this.errors = { super_cliente: ["Seleccione el supercliente"] };
        Notifications.alert.error("Cotización", "Seleccione el supercliente");
        return;
      }
      const payload = {
        tienda: this.current.tienda,
        email: this.current.email || null,
        fecha_vence: this.fecha_vence_input || null,
      };
      // Cotizaciones anteriores sin supercliente: solo se envia si se selecciono uno
      if (this.superClienteSel) {
        payload.super_cliente = this.superClienteSel.codigo;
      }
      if (this.current.id) {
        payload.id = this.current.id;
      } else if (this.$route.query.req) {
        // Creada desde el requerimiento: el backend la asigna a el
        payload.req_traslado = String(this.$route.query.req);
      }
      DynamicService.save(MODULO, PATH, payload)
        .then((response) => {
          Notifications.toast.success("Cotización", "Se guardó la información");
          if (!this.current.id) {
            this.$router.push({
              name: "inventario-cotizaciones-requerimiento-editar",
              params: { id: response.data.id },
            });
          } else {
            this.refreshCurrent();
          }
        })
        .catch((error) => this.mostrarError("Cotización", error));
    },
    showModalAddDetail() {
      this.detalle = detalleVacio();
      $("#modalAddDetailCotizacionReq").modal();
    },
    onChangeProducto(producto) {
      if (!producto || !producto.sku) {
        return;
      }
      ProductosService.getById(producto.sku).then((response) => {
        const prod = response.data;
        if (prod.productounidadmedida_set && prod.productounidadmedida_set.length > 0) {
          prod.unidad_medida = prod.productounidadmedida_set[0].unidad_medida.id;
        }
        this.detalle.producto = prod;
      });
    },
    agregarLinea() {
      if (!this.detalle.producto || !this.detalle.producto.sku) {
        this.detalle.errors = { detail: "Seleccione un producto" };
        return;
      }
      DynamicService.postAction(MODULO, PATH, this.current.id, "agregar_detalle", {
        producto: this.detalle.producto.sku,
        unidad_medida: this.detalle.producto.unidad_medida,
        cantidad_um: this.detalle.cantidad_um,
      })
        .then((response) => {
          Notifications.toast.success(
            "Producto Agregado",
            `SKU ${this.detalle.producto.sku} añadido a la cotización.`
          );
          this.mostrarAdvertencias(response.data.advertencias);
          this.detalle = detalleVacio();
          this.$refs.cerrarModal.click();
          this.refreshCurrent();
        })
        .catch((error) => {
          const data = (error.response && error.response.data) || {};
          this.detalle.errors = data.detail ? data : { detail: JSON.stringify(data) };
        });
    },
    modificarLinea(linea) {
      if (!linea.cantidad_um || Number(linea.cantidad_um) <= 0) {
        Notifications.toast.error("Cotización", "La cantidad debe ser mayor a cero");
        return;
      }
      DynamicService.postAction(MODULO, PATH, this.current.id, "modificar_detalle", {
        id: linea.id,
        cantidad_um: linea.cantidad_um,
      })
        .then(() => this.refreshCurrent())
        .catch((error) => this.mostrarError("Modificar línea", error));
    },
    eliminarLinea(linea) {
      Notifications.alert.confirm(
        "Cotización",
        "¿Está seguro de eliminar la línea?",
        "Sí, eliminar",
        () => {
          DynamicService.postAction(MODULO, PATH, this.current.id, "eliminar_detalle", { id: linea.id })
            .then(() => this.refreshCurrent())
            .catch((error) => this.mostrarError("Eliminar línea", error));
        }
      );
    },
    ejecutarAccion(accion, titulo, pregunta, textoBoton, mensajeOk) {
      Notifications.alert.confirm(titulo, pregunta, textoBoton, () => {
        DynamicService.postAction(MODULO, PATH, this.current.id, accion)
          .then(() => {
            Notifications.toast.success(titulo, mensajeOk);
            this.refreshCurrent();
          })
          .catch((error) => this.mostrarError(titulo, error));
      });
    },
    cerrar() {
      // Si se creo desde un requerimiento ya esta asignada: al cerrarla se cargan
      // sus productos en el requerimiento y se muestra el resultado.
      const titulo = "Cerrar Cotización";
      const req = this.current.requerimiento;
      const pregunta = req
        ? `Al cerrarla, sus productos se agregarán al requerimiento #${req.numero} y la cotización ya no podrá modificarse. ¿Desea continuar?`
        : "Una vez cerrada podrá asignarse a un requerimiento. ¿Desea continuar?";
      Notifications.alert.confirm(titulo, pregunta, "Sí, cerrar", () => {
        DynamicService.postAction(MODULO, PATH, this.current.id, "cerrar")
          .then((response) => {
            const carga = response && response.data ? response.data.carga_requerimiento : null;
            if (!mostrarResumenCargaCotizacion(carga)) {
              Notifications.toast.success(titulo, "Cotización cerrada");
            }
            this.refreshCurrent();
          })
          .catch((error) => this.mostrarError(titulo, error));
      });
    },
    abrir() {
      this.ejecutarAccion(
        "abrir",
        "Abrir Cotización",
        "¿Desea abrir la cotización para editarla?",
        "Sí, abrir",
        "Cotización abierta"
      );
    },
    anular() {
      this.ejecutarAccion(
        "anular",
        "Anular Cotización",
        "¿Desea anular la cotización?",
        "Sí, anular",
        "Cotización anulada"
      );
    },
    clonar() {
      Notifications.alert.confirm(
        "Clonar Cotización",
        `¿Está seguro de duplicar la cotización #${this.current.numero}?`,
        "Sí, duplicar",
        () => {
          DynamicService.postAction(MODULO, PATH, this.current.id, "clonar")
            .then((response) => {
              Notifications.toast.success(
                "Cotización Clonada",
                `Se creó la cotización #${response.data.numero}`
              );
              this.mostrarAdvertencias(response.data.advertencias);
              this.$router.push({
                name: "inventario-cotizaciones-requerimiento-editar",
                params: { id: response.data.cotizacion_e },
              });
            })
            .catch((error) => this.mostrarError("Clonar Cotización", error));
        }
      );
    },
    trasladarATienda() {
      this.$refs.modalTraslado.abrir();
    },
    onTrasladada(data) {
      Notifications.toast.success(
        "Cotización Trasladada",
        `Se creó la cotización #${data.numero} a partir de la #${data.numero_origen} de la tienda ${data.tienda_origen}, que quedó anulada.`
      );
      this.mostrarAdvertencias(data.advertencias);
      this.$router.push({
        name: "inventario-cotizaciones-requerimiento-editar",
        params: { id: data.cotizacion_e },
      });
    },
  },
};
</script>
